export default {
  items: [],
  serverItemsLength: 0,
  selected: [],
  dispute: {},
  disputeReasons: [],
};
